var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.943848 14.9057H4.69385L15.7538 3.8457L12.0038 0.0957031L0.943848 11.1557V14.9057ZM2.94385 11.9857L12.0038 2.9257L12.9238 3.8457L3.86385 12.9057H2.94385V11.9857Z",
    fill: "#14AE5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon1);
export default __webpack_public_path__ + "static/media/Edit_icon1.0cfeee5a3272be07ef5737781c4b335e.svg";
export { ForwardRef as ReactComponent };